module.exports = __webpack_public_path__ + "media/images/announce-d18a5955b141c6753d983ae8bf3a8411.svg";